document.addEventListener('DOMContentLoaded', function () {
    const headerSection = document.querySelector('.Header_section');
    let lastScrollTop = 0;

    function handleScroll() {
      // Don't hide header when search is open
      const searchBox = document.querySelector('.template-search__search');
      if (searchBox && !searchBox.classList.contains('hidden')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        headerSection.style.top = `-${headerSection.offsetHeight}px`;
        headerSection.style.transition = 'top 0.3s ease-in-out';
      } else {
        // Scrolling up
        headerSection.style.top = '0';
        headerSection.style.transition = 'top 0.3s ease-in-out';
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener('scroll', handleScroll);
  });
